function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { FieldAriaController } from '@vaadin/a11y-base/src/field-aria-controller.js';
import { ControllerMixin } from '@vaadin/component-base/src/controller-mixin.js';
import { ErrorController } from './error-controller.js';
import { HelperController } from './helper-controller.js';
import { LabelMixin } from './label-mixin.js';
import { ValidateMixin } from './validate-mixin.js';
/**
 * A mixin to provide common field logic: label, error message and helper text.
 *
 * @polymerMixin
 * @mixes ControllerMixin
 * @mixes LabelMixin
 * @mixes ValidateMixin
 */

export var FieldMixin = function FieldMixin(superclass) {
  return /*#__PURE__*/function (_ValidateMixin) {
    _inherits(FieldMixinClass, _ValidateMixin);

    var _super = _createSuper(FieldMixinClass);

    function FieldMixinClass() {
      var _this;

      _classCallCheck(this, FieldMixinClass);

      _this = _super.call(this);
      _this._fieldAriaController = new FieldAriaController(_assertThisInitialized(_this));
      _this._helperController = new HelperController(_assertThisInitialized(_this));
      _this._errorController = new ErrorController(_assertThisInitialized(_this));

      _this._errorController.addEventListener('slot-content-changed', function (event) {
        _this.toggleAttribute('has-error-message', event.detail.hasContent);
      });

      _this._labelController.addEventListener('slot-content-changed', function (event) {
        var _event$detail = event.detail,
            hasContent = _event$detail.hasContent,
            node = _event$detail.node;

        _this.__labelChanged(hasContent, node);
      });

      _this._helperController.addEventListener('slot-content-changed', function (event) {
        var _event$detail2 = event.detail,
            hasContent = _event$detail2.hasContent,
            node = _event$detail2.node;

        _this.toggleAttribute('has-helper', hasContent);

        _this.__helperChanged(hasContent, node);
      });

      return _this;
    }
    /**
     * @protected
     * @return {HTMLElement}
     */


    _createClass(FieldMixinClass, [{
      key: "_errorNode",
      get: function get() {
        return this._errorController.node;
      }
      /**
       * @protected
       * @return {HTMLElement}
       */

    }, {
      key: "_helperNode",
      get: function get() {
        return this._helperController.node;
      }
      /** @protected */

    }, {
      key: "ready",
      value: function ready() {
        _get(_getPrototypeOf(FieldMixinClass.prototype), "ready", this).call(this);

        this.addController(this._fieldAriaController);
        this.addController(this._helperController);
        this.addController(this._errorController);
      }
      /** @private */

    }, {
      key: "__helperChanged",
      value: function __helperChanged(hasHelper, helperNode) {
        if (hasHelper) {
          this._fieldAriaController.setHelperId(helperNode.id);
        } else {
          this._fieldAriaController.setHelperId(null);
        }
      }
      /** @protected */

    }, {
      key: "_accessibleNameChanged",
      value: function _accessibleNameChanged(accessibleName) {
        this._fieldAriaController.setAriaLabel(accessibleName);
      }
      /** @protected */

    }, {
      key: "_accessibleNameRefChanged",
      value: function _accessibleNameRefChanged(accessibleNameRef) {
        this._fieldAriaController.setLabelId(accessibleNameRef, true);
      }
      /** @private */

    }, {
      key: "__labelChanged",
      value: function __labelChanged(hasLabel, labelNode) {
        // Label ID should be only added when the label content is present.
        // Otherwise, it may conflict with an `aria-label` attribute possibly added by the user.
        if (hasLabel) {
          this._fieldAriaController.setLabelId(labelNode.id);
        } else {
          this._fieldAriaController.setLabelId(null);
        }
      }
      /**
       * @param {string | null | undefined} errorMessage
       * @protected
       */

    }, {
      key: "_errorMessageChanged",
      value: function _errorMessageChanged(errorMessage) {
        this._errorController.setErrorMessage(errorMessage);
      }
      /**
       * @param {string} helperText
       * @protected
       */

    }, {
      key: "_helperTextChanged",
      value: function _helperTextChanged(helperText) {
        this._helperController.setHelperText(helperText);
      }
      /**
       * @param {HTMLElement | null | undefined} target
       * @protected
       */

    }, {
      key: "_ariaTargetChanged",
      value: function _ariaTargetChanged(target) {
        if (target) {
          this._fieldAriaController.setTarget(target);
        }
      }
      /**
       * @param {boolean} required
       * @protected
       */

    }, {
      key: "_requiredChanged",
      value: function _requiredChanged(required) {
        this._fieldAriaController.setRequired(required);
      }
      /**
       * @param {boolean} invalid
       * @protected
       */

    }, {
      key: "_invalidChanged",
      value: function _invalidChanged(invalid) {
        var _this2 = this;

        this._errorController.setInvalid(invalid); // This timeout is needed to prevent NVDA from announcing the error message twice:
        // 1. Once adding the `[role=alert]` attribute when updating `has-error-message` (OK).
        // 2. Once linking the error ID with the ARIA target here (unwanted).
        // Related issue: https://github.com/vaadin/web-components/issues/3061.


        setTimeout(function () {
          // Error message ID needs to be dynamically added / removed based on the validity
          // Otherwise assistive technologies would announce the error, even if we hide it.
          if (invalid) {
            var node = _this2._errorNode;

            _this2._fieldAriaController.setErrorId(node && node.id);
          } else {
            _this2._fieldAriaController.setErrorId(null);
          }
        });
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * A target element to which ARIA attributes are set.
           * @protected
           */
          ariaTarget: {
            type: Object,
            observer: '_ariaTargetChanged'
          },

          /**
           * Error to show when the field is invalid.
           *
           * @attr {string} error-message
           */
          errorMessage: {
            type: String,
            observer: '_errorMessageChanged'
          },

          /**
           * String used for the helper text.
           * @attr {string} helper-text
           */
          helperText: {
            type: String,
            observer: '_helperTextChanged'
          },

          /**
           * String used to label the component to screen reader users.
           * @attr {string} accessible-name
           */
          accessibleName: {
            type: String,
            observer: '_accessibleNameChanged'
          },

          /**
           * Id of the element used as label of the component to screen reader users.
           * @attr {string} accessible-name-ref
           */
          accessibleNameRef: {
            type: String,
            observer: '_accessibleNameRefChanged'
          }
        };
      }
    }, {
      key: "observers",
      get: function get() {
        return ['_invalidChanged(invalid)', '_requiredChanged(required)'];
      }
    }]);

    return FieldMixinClass;
  }(ValidateMixin(LabelMixin(ControllerMixin(superclass))));
};